export default __webpack_public_path__ + "static/media/img_post2.f5d8dabf.png";